import { render } from "./commodity.vue?vue&type=template&id=eecb9fce&scoped=true&ts=true"
import script from "./commodity.vue?vue&type=script&lang=ts"
export * from "./commodity.vue?vue&type=script&lang=ts"

import "./commodity.vue?vue&type=style&index=0&id=eecb9fce&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eecb9fce"]])

export default __exports__